let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7VNjW")).then(() => parcelRequire('7eZoy'));